import type { KeyChord } from "../../../services/commands/commands.types";
import type { ShortcutGroup, ShortcutPair } from "../ShortcutsDialog";

/** Voice chord (Shift+Mod+V). Mod+M minimises the window on a Mac. */
export const VOICE_CHORD: KeyChord = { key: "v", mod: true, shift: true };

/**
 * Keys the sheet lists that no registry action carries. Ask, Settings, Light / dark and Search and commands
 * (Mod+K, the palette.open action) are listed from the registry, so their rows are not repeated here.
 * Voice is bound by the command palette host, where the voice provider is on.
 */
export const EVERYWHERE_SHORTCUTS: ShortcutGroup = {
  id: "everywhere",
  label: "Everywhere",
  rows: [{ id: "static-voice", label: "Voice", chords: [VOICE_CHORD] }],
};

/** Rows the sheet shows as one (design F20): each reads "A / B" with both key sets. A pair missing a row is skipped. */
export const SHORTCUT_PAIRS: readonly ShortcutPair[] = [
  { ids: ["history.undo", "history.redo"], label: "Undo / Redo" },
  { ids: ["grid.move", "grid.resize"], label: "Move / Resize (Build mode)", onlyKey: "ArrowLeft" },
];
